// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"881":"de0a0d6b","921":"f7080e87"}[chunkId] + ".js";
};